import { get } from 'lodash-es'
import { stringify } from 'qs'
import axios from 'axios'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules.js'
// import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import { REQUEST_STATE } from './constants'
import { TYPES as MUTATION_TYPES } from './mutations'
import { SETS } from './state'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'

export const TYPES = {
  CALL_MESSAGES: 'CALL_MESSAGES',
  GET_MESSAGES_LIST: 'GET_MESSAGES_LIST',
  GET_MESSAGES_INFO: 'GET_MESSAGES_INFO',
}

export default {
  [TYPES.GET_MESSAGES_INFO]: ({ commit, dispatch, rootGetters }) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.HAS_ROLE}`](
        DP_ROLE.MESSAGING_INFORMATIONS_R.p,
      )
    ) {
      return Promise.resolve({})
    }

    const set = SETS.MESSAGES_INFO
    const promise = dispatch(TYPES.CALL_MESSAGES, {
      set,
      path: '/api/event_user_status',
    })
      .then(response => {
        commit(MUTATION_TYPES[set], {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        // if (status === 404) {
        // }

        commit(MUTATION_TYPES[set], {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES[set], { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
  [TYPES.CALL_MESSAGES]: (
    { rootGetters },
    { method = 'get', data, path = '/api/event_user' } = {},
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.HAS_ROLE}`](
        DP_ROLE.MESSAGING_INFORMATIONS_R.p,
      )
    ) {
      return
    }
    const domain = rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGING_DOMAIN}`]
    if (!domain) {
      return
      // return Promise.reject(new Error(`MESSAGING::Missing Messaging domain!`))
    }

    // const token = rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGING_TOKEN}`]

    const params = {
      method,
      url: `${window.location.protocol}//${domain}${path}${
        method === 'get' && data ? `?${stringify(data)}` : ''
      }`,
      // headers: {
      //   Authorization: `Bearer ${token}`,
      // },
    }

    if (method === 'post' && data) {
      params.data = data
    }

    return axios(params)
    // .then(response => {
    //   commit(MUTATION_TYPES[set], {
    //     type: REQUEST_STATE.STATE_SUCCESS,
    //     data: response.data,
    //     status: response.status,
    //   })
    //   return response
    // })
    // .catch(error => {
    //   const status = get(error, 'response.status', 400)

    //   // if (status === 404) {
    //   // }

    //   commit(MUTATION_TYPES[set], {
    //     type: REQUEST_STATE.STATE_FAILURE,
    //     data: {},
    //     status: status,
    //     errorMessage: error.message,
    //   })
    //   return Promise.reject(new Error(error.message))
    // })

    // commit(MUTATION_TYPES[set], { type: REQUEST_STATE.STATE_PENDING, promise })

    // return promise
  },
  [TYPES.GET_MESSAGES_LIST]: (
    { commit, dispatch, rootGetters },
    { method = 'get', data, set = SETS.MESSAGES } = {},
  ) => {
    if (
      !rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.HAS_ROLE}`](
        DP_ROLE.MESSAGING_INFORMATIONS_R.p,
      )
    ) {
      return
    }
    // console.log('GET_MESSAGES_LIST')
    // const domain = rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGING_DOMAIN}`]
    // if (!domain) {
    //   return Promise.reject(new Error(`MESSAGING::Missing Messaging domain!`))
    // }

    // const token = rootGetters[`${STORE_MODULES.APP}/${APP_GETTER.MESSAGING_TOKEN}`]

    // // Params
    // // sortByDesc=type
    // // filter[type]=availability.again
    // // filter[read]=1
    // // filter[sent_mail]=null
    // // filter[data]=637529022
    // // limit=3
    // // page=1

    // const params = {
    //   method,
    //   url: `${window.location.protocol}//${domain}/api/event_user${
    //     method === 'get' && data ? `?${stringify(data)}` : ''
    //   }`,
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // }

    // if (method === 'post' && data) {
    //   params.data = data
    // }
    // console.log(params)
    const promise = dispatch(TYPES.CALL_MESSAGES, {
      method,
      data,
      set,
    })
      .then(response => {
        commit(MUTATION_TYPES[set], {
          type: REQUEST_STATE.STATE_SUCCESS,
          data: response.data,
          status: response.status,
        })
        return response.data
      })
      .catch(error => {
        const status = get(error, 'response.status', 400)

        // if (status === 404) {
        // }

        commit(MUTATION_TYPES[set], {
          type: REQUEST_STATE.STATE_FAILURE,
          data: {},
          status: status,
          errorMessage: error.message,
        })
        // return Promise.reject(new Error(error.message))
        return {}
      })

    commit(MUTATION_TYPES[set], { type: REQUEST_STATE.STATE_PENDING, promise })

    return promise
  },
}
